import styled from "@emotion/styled";
import { css } from "@emotion/react";
import theme from "../../styles/theme";

export const EntryBase = styled.div<{
  isActive: boolean;
  isAdjacentActive: boolean;
}>`
  border-top: ${(props) =>
    props.isActive ? `1px solid ${theme.colors.blues[100]} ` : `0`};

  /* Don't display border if entry below is active */
  border-bottom: ${(props) =>
    props.isAdjacentActive ? `0` : css`1px solid #d8dee1`};
`;

export const HeaderBase = styled.div<{ isOpen: boolean }>`
  display: flex;
  color: ${theme.colors.darkBlues[75]};
  padding: 12px 8px 12px 8px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.darkBlues[5]};
  }

  &:active {
    background-color: ${theme.colors.darkBlues[5]}80;
  }
`;

export const HeaderText = styled.div`
  flex: 1;
`;

export const Arrow = styled.i<{ isOpen: boolean }>`
  height: fit-content;
  line-height: 24px;
  transition: all 0.35s;
  transform: ${(props) => (props.isOpen ? `rotate(-180deg)` : ``)};
`;

export const Image = styled.img<{ isOpen: boolean }>`
  object-fit: cover;
  height: 303px;
  opacity: ${(props) => (props.isOpen ? "1" : "0")};
  transition: all 0.25s;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 12px;
  margin-top: 6px;

  /* Only display on mobile */
  ${theme.largerThan.lg} {
    display: none;
  }
`;

export const Content = styled.div<{
  isOpen: boolean;
  contentHeight: number | undefined;
  listHeight: number;
}>`
  color: ${theme.colors.darkBlues[75]};
  font-size: 16px;
  padding-left: 8px;
  line-height: 24px;
  overflow: hidden;
  transition: all 0.25s;
  margin: ${(props) => (props.isOpen ? `12px 0` : `0`)};

  /* Implicitly set height to give expansion transition effect */
  height: ${(props) =>
    props.isOpen ? props.contentHeight && props.contentHeight : `0`}px;

  ${theme.largerThan.lg} {
    /* Set max height to scroll any content that would overflow parent component */
    max-height: ${(props) => 472 - props.listHeight}px;
    overflow: ${(props) => {
      if (props.contentHeight && props.contentHeight > 472 - props.listHeight)
        return `auto`;
      else return `hidden`;
    }};
  }
`;
